import $ from 'jquery'
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

const $window = $(window)

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((from, to, next) => {
  $window.trigger('router.beforeEach', [router])
  next()
})

export default router